<template>
  <b-form-group
    label="Sıra No"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Sıra No"
      rules="required"
    >
      <cleave
        v-model="dataItem.ordering"
        class="form-control"
        :raw="true"
        :options="options.number"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import {
  BFormGroup,
} from 'bootstrap-vue'

export default {
  name: 'ProductsOrdering',
  components: {
    Cleave,
    ValidationProvider,
    BFormGroup,
  },

  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
